import TheGrid from '@/views/emailcampaigns/grid'
import Edit from '@/views/emailcampaigns/edit'
import TheView from '@/views/emailcampaigns/view'

export default {
  path: '/email/campaigns',
  redirect: '/email/campaigns/index',
  name: 'emailcampaigns',
  meta: {
    auth: {
      redirect: {
        name: 'emailcampaigns.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'campaigns de email'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'emailcampaigns.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'emailcampaigns.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'emailcampaigns.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'emailcampaigns.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
